import {redirect, useLoaderData, useParams, useNavigate} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import Input from "../../components/ui/Input";
import Select from "../../components/ui/Select";
import Uploader from "../../components/ui/Uploader";
import Cookies from "js-cookie";
import {Spin} from 'antd';
import {useState} from "react";
import BackButton from "../../components/BackButton";

const AssignSupervisor = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(false)
    const {tournament, team} = useLoaderData();

    const [assignSelf, setAssignSelf] = useState(false)
    const [name, setName] = useState('')
    const [lastname, setLastname] = useState('')
    const [mobile, setMobile] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [idNumber, setIdNumber] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [birthday, setBirthday] = useState('')
    const [city, setCity] = useState('')
    const [workExperience, setWorkExperience] = useState('')
    const [email, setEmail] = useState('')
    const [gender, setGender] = useState('')
    const [height, setHeight] = useState('')
    const [weight, setWeight] = useState('')
    const [educationLevel, setEducationLevel] = useState('')
    const [fieldOfStudy, setFieldOfStudy] = useState('')
    const [image, setImage] = useState(null)
    const [certificates, setCertificates] = useState(null)
    const [insuranceHistory, setInsuranceHistory] = useState(null)

    async function submitFormHandler() {
        if (!assignSelf && (!name || !lastname || !mobile)) {
            alert('لطفا تمام فیلدها را پر کنید');
            return;
        }

        setLoading(true)
        let data = new FormData();

        if (assignSelf) {
            data.append('assign_self', '1');
        } else {
            data.append('name', name);
            data.append('lastname', lastname);
            data.append('mobile', mobile);
        }

        // Common fields for both assign_self and manual
        data.append('father_name', fatherName);
        data.append('id_number', idNumber);
        data.append('national_code', nationalCode);
        data.append('birthday', birthday);
        data.append('city', city);
        data.append('work_experience', workExperience);
        data.append('email', email);
        data.append('gender', gender);
        data.append('height', height);
        data.append('weight', weight);
        data.append('education_level', educationLevel);
        data.append('field_of_study', fieldOfStudy);
        if (certificates) data.append('certificates', certificates);
        if (insuranceHistory) data.append('insurance_history', insuranceHistory);
        if (image) data.append('image', image);

        const url = `${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/hse-manager/teams/${params.team_id}/assign-supervisor`;
        await HttpRequest(url, (res) => {
            navigate(`/tournament/${params.id}/hse-manager/teams`)
        }, 'post', data)
        setLoading(false)
    }

    return <div>
        <BackButton src={`/tournament/${params.id}/hse-manager/teams`}/>
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    <img src="/icons/icon-4.png" className="inline me-3 w-[25px] h-[25px]"/>
                    تعیین سرپرست — {team.name}
                </div>
            </div>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">

                {/* Option to assign self */}
                <div className="w-[90%] md:w-[30%] mx-auto mb-6">
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="checkbox"
                            checked={assignSelf}
                            onChange={(e) => setAssignSelf(e.target.checked)}
                            className="w-4 h-4"
                        />
                        <span className="text-[15px] text-orange font-bold">
                            خودم به عنوان سرپرست ثبت شوم
                        </span>
                    </label>
                </div>

                {!assignSelf && (
                    <>
                        <Input title="نام" changeValueHandler={setName} value={name}
                               placeholder="نام سرپرست را وارد کنید"/>
                        <Input title="نام خانوادگی" changeValueHandler={setLastname} value={lastname}
                               placeholder="نام خانوادگی سرپرست را وارد کنید"/>
                        <Input title="شماره موبایل" changeValueHandler={setMobile} value={mobile}
                               placeholder="09125268579 به عنوان مثال"/>
                    </>
                )}

                {/* Common fields for all roles */}
                <Input title="نام پدر" changeValueHandler={setFatherName} value={fatherName} placeholder=""/>
                <Input title="کد ملی" changeValueHandler={setNationalCode} value={nationalCode} placeholder=""/>
                <Input title="شماره شناسنامه" changeValueHandler={setIdNumber} value={idNumber} placeholder=""/>
                <Input title="تاریخ تولد" changeValueHandler={setBirthday} value={birthday}
                       placeholder="1369/02/02"/>
                <Input title="محل صدور شناسنامه" changeValueHandler={setCity} value={city} placeholder=""/>
                <Input title="سابقه کار(سال)" changeValueHandler={setWorkExperience} value={workExperience}
                       placeholder="میزان سابقه کار را به سال وارد کنید"/>
                <Input title="ایمیل" changeValueHandler={setEmail} value={email} placeholder=""/>
                <Select title="جنسیت" changeValueHandler={setGender} value={gender} placeholder="انتخاب کنید"
                        options={[
                            {value: 'man', label: 'آقا'},
                            {value: 'woman', label: 'خانم'}
                        ]}/>
                <Input title="قد" changeValueHandler={setHeight} value={height} placeholder=""/>
                <Input title="وزن" changeValueHandler={setWeight} value={weight} placeholder=""/>
                <Select title="مقطع تحصیلی" changeValueHandler={setEducationLevel} value={educationLevel}
                        placeholder="انتخاب کنید" options={[
                    {value: 'd1', label: 'دیپلم'},
                    {value: 'd2', label: 'کارشناسی'},
                    {value: 'd3', label: 'کارشناسی ارشد'},
                    {value: 'd4', label: 'دکترا'}
                ]}/>
                <Input title="رشته تحصیلی" changeValueHandler={setFieldOfStudy} value={fieldOfStudy}
                       placeholder=""/>
                <Uploader changeValueHandler={setInsuranceHistory} value={insuranceHistory?.name}
                          title="سابقه بیمه و تاییدیه مدیر HSE (حداکثر 200k)"/>
                <Uploader changeValueHandler={setCertificates} value={certificates?.name}
                          title="گواهینامه ها(فایل zip,rar حداکثر 500 k)"/>
                <Uploader changeValueHandler={setImage} value={image?.name} title="عکس 3*4 (حداکثر 100 k)"/>

                <div className={`w-[90%] md:w-[30%] mx-auto text-center`}>
                    <button onClick={submitFormHandler} disabled={loading}
                            className={`bg-gray2 text-center rounded py-3 w-[60%] text-white`}>
                        {loading ? <Spin/> : 'ثبت سرپرست'}
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default AssignSupervisor;

export async function AssignSupervisorLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/hse-manager/teams`, (res) => {
                data = res.data;
                // Find the specific team
                data.team = data.teams.find(t => t.id === parseInt(params.team_id));
                if (!data.team) {
                    throw new Error('تیم یافت نشد');
                }
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}
